function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { FaChevronRight } from 'react-icons/fa6';
import { useState } from 'react';
import { connect } from 'react-redux';
import { appActions } from '../../reducers/app.reducer';
import { modalActions } from '../../reducers/modal.reducer';
import { useLocation } from 'react-router-dom';
import Popup from '../modal/Popup.modal';
var MobileMenuItem = function MobileMenuItem(_ref) {
  var data = _ref.data,
    nav = _ref.nav,
    toggleHamburgerMenuAction = _ref.toggleHamburgerMenuAction,
    showModalAction = _ref.showModalAction;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var _useLocation = useLocation(),
    pathname = _useLocation.pathname;
  var navigate = useNavigate();
  var handleOnNavigate = function handleOnNavigate(data) {
    var item = data.item,
      type = data.type;
    if (item.internalUrl) navigate(item.internalUrl);
    if (item.externalUrl) window.open(item.externalUrl, '_blank');
    if (item.popup) {
      showModalAction({
        component: /*#__PURE__*/React.createElement(Popup, {
          popupID: item.popup
        })
      });
    }
    if (item.children && type === 'child') {
      $('#mm_parent_' + item._id).css({
        'color': $('#mm_child_' + item._id).height() === 0 ? '#ffffff' : '#7d7d7d'
      });
      $('#mm_child_' + item._id).css({
        'height': $('#mm_child_' + item._id).height() === 0 ? $('#mm_child_' + item._id)[0].scrollHeight : 0
      });
    } else if (item.children && type === 'subChild') {
      if ($('#mm_sub-child_' + item._id).height() === 0) {
        $('#mm_sub-child_' + item._id).css({
          'height': nav.filter(function (x) {
            return x.parentID === item._id;
          }).length * 77
        });
        $('#mm_child_' + item.parentID).css({
          // 'height': $('#mm_child_'+item.parentId)[0].scrollHeight + item.children.length * 77,
          'height': $('#mm_child_' + item.parentID)[0].scrollHeight + nav.filter(function (x) {
            return x.parentID === item._id;
          }).length * 77
        });
        setOpen(item._id);
      } else if (type === 'subChild') {
        $('#mm_sub-child_' + item._id).css({
          'height': 0
        });
        $('#mm_child_' + item.parentID).css({
          'height': $('#mm_child_' + item.parentID)[0].scrollHeight - nav.filter(function (x) {
            return x.parentID === item._id;
          }).length * 77
        });
        setOpen(false);
      }
    } else {
      toggleHamburgerMenuAction();
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "mobile-menu__item"
  }, /*#__PURE__*/React.createElement("div", {
    className: ['mobile-menu-item__parent', pathname === data.internalUrl ? 'mobile-menu-item__parent--active' : ''].join(' '),
    id: 'mm_parent_' + data._id,
    onClick: function onClick() {
      return handleOnNavigate({
        item: data,
        type: 'child'
      });
    }
  }, /*#__PURE__*/React.createElement("p", null, data.title)), data.children && /*#__PURE__*/React.createElement("div", {
    className: "mobile-menu-item__child",
    id: 'mm_child_' + data._id
  }, nav.filter(function (x) {
    return x.parentID === data._id;
  }).map(function (item, i) {
    return /*#__PURE__*/React.createElement("div", {
      className: 'mobile-menu-item__child--item ',
      id: 'mm_child_' + item._id,
      key: 'mm_child_' + item._id,
      onClick: function onClick(e) {
        if (e.target.id.includes(item._id)) {
          handleOnNavigate({
            item: item,
            type: 'subChild'
          });
        }
      }
    }, /*#__PURE__*/React.createElement(FaChevronRight, null), /*#__PURE__*/React.createElement("span", {
      className: [open === item._id ? 'mobile-menu-item__child--selected' : '', pathname === item.internalUrl ? 'mobile-menu-item__child--selected' : ''].join(' '),
      id: "span".concat(item._id)
    }, item.title), item.children && /*#__PURE__*/React.createElement("div", {
      className: "mobile-menu-item__sub-child",
      id: 'mm_sub-child_' + item._id
    }, nav.filter(function (x) {
      return x.parentID === item._id;
    }).map(function (x) {
      return /*#__PURE__*/React.createElement("div", {
        className: "mobile-menu-item__sub-child--item",
        id: 'mm_sub-child_' + x._id,
        key: 'mm_sub-child_' + x._id,
        onClick: function onClick(e) {
          if (e.target.id.includes(x._id)) handleOnNavigate({
            item: x,
            type: 'grandChild'
          });
        }
      }, /*#__PURE__*/React.createElement("span", {
        id: "span".concat(x._id),
        className: pathname === x.internalUrl ? 'mobile-menu-item__child--selected' : ''
      }, x.title));
    })));
  })));
};
var mdtp = {
  toggleHamburgerMenuAction: appActions.toggleHamburgerMenu,
  showModalAction: modalActions.show
};
export default connect(null, mdtp)(MobileMenuItem);